function NumberFormat(number = 0) {

    return number.toLocaleString('fr-FR');
}

export default NumberFormat;
